import Vue from "vue";
import AccountLogin from "@PrivateAreaScripts/Components/Account/AccountLogin.vue";
import AccountLogout from "@PrivateAreaScripts/Components/Account/AccountLogout.vue";
import AccountPasswordRemind from "@PrivateAreaScripts/Components/Account/AccountPasswordRemind.vue";
import AccountPasswordReset from "@PrivateAreaScripts/Components/Account/AccountPasswordReset.vue";

export default class AppConfig {
    public static AddComponents() {
        Vue.component("app-accountlogin", AccountLogin);
        Vue.component("app-accountlogout", AccountLogout);
        Vue.component("app-accountpasswordremind", AccountPasswordRemind);
        Vue.component("app-accountpasswordreset", AccountPasswordReset);
    }
}